import Component from 'inferno-component';
import {
  Card,
  Grid,
  Icon,
  Image,
  Reveal,
  Responsive
} from 'semantic-ui-react';

const underDeploymentStyle = {
  float: 'left',
  position: 'absolute',
  top: '45%',
  zIndex: '1000',
  textAlign: 'center',
  width: '100%',
  fontSize: '1.5rem',
  fontWeight: 'bold',
  color: '#FF4D4D',
  backgroundColor: 'rgba(128, 128, 128, 0.8)'
}

export class Location extends Component {
  constructor(props) {
    super(props)

    this.showReveal = this.showReveal.bind(this)
    this.renderMobileImage = this.renderMobileImage.bind(this)
    this.handleUnderDeployment = this.handleUnderDeployment.bind(this)
  }

  renderMobileImage(location) {
    return (
      <Responsive maxWidth={Responsive.onlyTablet.maxWidth}>
        {this.handleUnderDeployment(location)}
      </Responsive>)
  }

  handleUnderDeployment(location) {
    return (
        location.underDeployment ?
        <div style={{position: 'relative', textAlign: 'center'}}>
          <div style={underDeploymentStyle}>Kihelyezés alatt</div>
          <Image src={this.props.location.image} />
        </div>
        : <Image src={this.props.location.image} />
    )
  }

  showReveal(location) {
    return (
      <Responsive minWidth={Responsive.onlyComputer.minWidth}>
        {
          location.revealEnabled ? <Reveal animated='move up'>
            <Reveal.Content visible>
              <Image src={this.props.location.image} />
            </Reveal.Content>
            <Reveal.Content hidden>
              <Image src={this.props.location.revealImage} />
            </Reveal.Content>
          </Reveal> : this.handleUnderDeployment(location)
          }
      </Responsive>)
  }

  render() {
    return (
      <Grid.Column
        stretched
        centered
        mobile={16}
        tablet={8}
        computer={5} >
        <Card color='grey' fluid raised centered style={{ backgroundColor: '#f5f5f5', marginBottom: '2rem' }}>
          <Card.Content>
            <Card.Header as='h5' color='grey' className='my-1' content={this.props.location.city} />
          </Card.Content>
          {this.renderMobileImage(this.props.location)}
          {this.showReveal(this.props.location)}
          <Card.Content style={{ minHeight: '110px' }}>
            <Card.Header as='h4' color='grey' className='my-1' content={this.props.location.name} />
            <Card.Header as='h5' color='grey' className='my-1' content={this.props.location.building} />
            <Card.Header as='h5' color='grey' className='my-1' content={this.props.location.note} />
          </Card.Content>
          <Card.Content extra>
            <Icon name={this.props.location.univeristy ? 'student' : 'users'} />
            {this.props.location.numberOfStudents}&nbsp;{this.props.location.univeristy ? "hallgató" : "fő"}
          </Card.Content>
          <Card.Content extra>
            <Icon name='eye' />
            Min. {this.props.location.displayPerMonth} megjelenés/hónap
          </Card.Content>
        </Card>
      </Grid.Column>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/locations/Location.js